import { Clock } from "lucide-react";

export default function SessionTimelineCard({ rows, tz }) {
  if (!rows?.length) return null;
  return (
    <div className="tp-card p-6 mt-6" data-testid="session-timeline-card">
      <div className="flex items-center gap-2 mb-4">
        <Clock className="w-4 h-4 text-indigo-500" />
        <div className="font-display font-semibold">Session Timeline</div>
        <span className="text-xs text-slate-500" data-testid="session-timeline-tz">({tz || "UTC"})</span>
      </div>
      <div className="grid sm:grid-cols-3 gap-x-6 gap-y-3">
        {rows.map((r) => (
          <div key={r.key} data-testid={`timeline-${r.key}`}>
            <div className="text-[11px] uppercase tracking-wider text-slate-500">{r.label}</div>
            <div className="text-sm font-mono">{r.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
